import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export const AverageNcRatio = ({ options }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [averageNcRatio, setAverageNcRatio] = useState(null);
    useEffect(() => {
        if (!options.isReady) {
            setIsLoading(false);
            setErrorMessage("");
            setAverageNcRatio(null);
            return;
        }
        setIsLoading(true);
        setErrorMessage("");
        setAverageNcRatio(null);
        const params = new URLSearchParams();
        params.append("year", String(options.year));
        params.append("quarter", String(options.quarter));
        options.fleetIds.forEach((id) => params.append("fleetIds", String(id)));
        fetch(`/api/insights/quarterly/ncratio?${params}`)
            .then((res) => {
            if (res.status === 204)
                return null;
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((data) => {
            setAverageNcRatio(data);
        })
            .catch((error) => {
            console.error(error);
            setErrorMessage("Error fetching NC ratio data");
        })
            .finally(() => setIsLoading(false));
    }, [options.isReady, options.year, options.quarter, options.fleetIds]);
    const ratioDisplay = averageNcRatio === null ? "N/A" : `${averageNcRatio}%`;
    return (_jsxs("div", { className: "card shadow h-100", children: [_jsx("h3", { className: "card-header", children: "Average NC Ratio" }), _jsxs("div", { className: "card-body d-flex flex-column", children: [(!options.isReady || isLoading) && (_jsxs("div", { className: "text-center py-4", children: [_jsx("span", { className: "spinner-grow spinner-grow-sm", role: "status", "aria-hidden": "true" }), " Loading..."] })), options.isReady && errorMessage && (_jsx("div", { className: "alert alert-danger", role: "alert", children: errorMessage })), options.isReady && !isLoading && averageNcRatio === null && (_jsx("p", { className: "text-muted mb-0", children: "No data available for this period." })), _jsx("div", { className: "mt-auto", children: averageNcRatio !== null && !isLoading && options.isReady && (_jsxs(_Fragment, { children: [_jsx("h1", { className: "mb-1", children: ratioDisplay }), _jsx("p", { className: "text-muted mb-0", children: "hours non-compliant vs hours worked" })] })) })] })] }));
};
